import { StandardEvents } from '@shopify/events';

/**
 * Size-dependent product description (user decision 2026-10-29).
 *
 * The description carries two spec groups — `.tee-spec--std` (S–2XL, the
 * 425 GSM blank) and `.tee-spec--big` (3XL–5XL, the 260 GSM blank) — and
 * `.product-information[data-size-group]` shows exactly one of them (CSS in
 * sections/product-information.liquid). Liquid renders the initial state
 * from `product.selected_variant`; the description block itself is never
 * re-rendered on a variant pick, so this listener mirrors the picked size
 * into the attribute once the picker's section fetch resolves.
 */

const BIG_SIZES = new Set(['3XL', '4XL', '5XL']);

/**
 * @param {{ options?: string[], option1?: string, title?: string } | null | undefined} variant
 * @returns {'std' | 'big' | null}
 */
function groupFor(variant) {
  if (!variant) return null;
  const values = Array.isArray(variant.options) ? variant.options : [variant.option1 ?? variant.title ?? ''];
  return values.some((value) => BIG_SIZES.has(String(value).trim())) ? 'big' : 'std';
}

document.addEventListener(StandardEvents.productSelect, (event) => {
  if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
  const root = event.target.closest('.product-information');
  if (!(root instanceof HTMLElement)) return;
  const promise = /** @type {Promise<{ detail?: { resource?: object | null } }> | undefined} */ (
    /** @type {any} */ (event).promise
  );
  if (!promise) return;
  promise
    .then(({ detail }) => {
      const group = groupFor(/** @type {any} */ (detail?.resource));
      if (group) root.dataset.sizeGroup = group;
    })
    .catch(() => {});
});
